import { render, staticRenderFns } from "./PriceChangeRecord.vue?vue&type=template&id=1dff2e7a"
import script from "./PriceChangeRecord.vue?vue&type=script&lang=ts"
export * from "./PriceChangeRecord.vue?vue&type=script&lang=ts"
import style0 from "./PriceChangeRecord.vue?vue&type=style&index=0&id=1dff2e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports